import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Modal} from '@softline/ui-core';
import { ReactiveFormsModule } from '@angular/forms';


import { TranslatePipe } from '@softline/ui-core';
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'lib-confirm-menge-above-max-menge-dialog',
    imports: [ReactiveFormsModule,
    TranslatePipe],
    templateUrl: './confirm-menge-above-max-menge-dialog.component.html',
    styleUrls: ['./confirm-menge-above-max-menge-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmMengeAboveMaxMengeDialogComponent implements Modal<boolean> {

  close!: (result: boolean) => void;

  registerCloseHandler(handler: (result: boolean) => void) {
    this.close = handler;
  }
}
